import React from 'react';
import { Dialog, Grid, CircularProgress, Typography } from '@quillbot/design-system';

const StyleSheet = {
  TextDialogWithCircularProgressContainer: {
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: 20,
    paddingRight: 20,
    overflow: 'hidden',
  } as React.CSSProperties,
  TextDialogWithCircularProgressTypography: { marginLeft: 10, fontSize: 14 } as React.CSSProperties,
};

export const TextDialogWithCircularProgress = ({
  message,
  open = true,
}: {
  message: string;
  open?: boolean;
}) => (
  <Dialog open={open}>
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      style={StyleSheet.TextDialogWithCircularProgressContainer}
    >
      <CircularProgress color="primary" />
      {message && (
        <Typography
          variant="subtitle2"
          color="textSecondary"
          style={StyleSheet.TextDialogWithCircularProgressTypography}
        >
          {message}
        </Typography>
      )}
    </Grid>
  </Dialog>
);
